export default __webpack_public_path__ + "static/media/loading-circle.cbac0c6a.svg";